<template>
  <div class="doctor-schedule">
    <loading-messages v-if="loading"></loading-messages>
    <template v-else>
      <div v-if="schedulesByPatient(patientId)" class="list-group">
        <div
          v-for="schedule in schedulesByPatient(patientId)"
          :key="schedule.id"
          class="list-group-item list-group-item-action"
        >
          <div class="d-flex w-100 justify-content-between align-items-center">
            <h5 class="row align-items-center no-gutters mb-0">
              <div class="col-auto mr-3 text-primary svg-lg">
                <LabIcon v-if="schedule.clinic_service.category_id === 'laboratory'"></LabIcon>
                <DiagnosticsIcon v-if="schedule.clinic_service.category_id === 'diagnostics'"></DiagnosticsIcon>
                <OnlineConsultationIcon v-if="schedule.clinic_service.category_id === 'consultation'"></OnlineConsultationIcon>
              </div>
              <div class="col-auto mr-2">
                <div>
                  {{ schedule.clinic_service.name[authLocale] }}
                </div>
                <small class="svg">
                  <online-consultation-icon
                    v-if="schedule.clinic_service.type === 'telemedicine'"
                  ></online-consultation-icon>
                  <clinic-icon
                    v-else-if="schedule.clinic_service.type === 'visit'"
                  ></clinic-icon>
                  <ambulance-icon
                    v-else-if="schedule.clinic_service.type === 'house_call'"
                  ></ambulance-icon>
                  <span>
                    {{ $t(schedule.clinic_service.type) }}
                  </span>
                </small>
              </div>
            </h5>
            <div>
              <h4 class="text-right mb-0">
                {{ schedule.start_time | moment("HH:mm") }}
                <small class="d-block">{{ schedule.start_time | moment("ddd, DD MMMM") }}</small>
              </h4>
              <div
                v-if="schedule.status === 'pending'"
              >
                <a
                  @click.prevent="createCase(schedule.id)"
                  class="btn btn-primary btn-sm svg-sm"
                  href="#"
                >
                  <case-icon></case-icon>
                  <span class="pl-2">{{ $t("createCase") }}</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import LoadingMessages from '@/components/Loadings/Message'
import OnlineConsultationIcon from '@/components/Icons/OnlineConsultation'
import ClinicIcon from '@/components/Icons/Clinic'
import AmbulanceIcon from '@/components/Icons/Ambulance'
import CaseIcon from '@/components/Icons/Case'
import LabIcon from '@/components/Icons/Lab'
import DiagnosticsIcon from '@/components/Icons/Diagnostics'
import { mapMutations, mapGetters } from 'vuex'
export default {
  components: {
    LoadingMessages,
    OnlineConsultationIcon,
    ClinicIcon,
    AmbulanceIcon,
    CaseIcon,
    LabIcon,
    DiagnosticsIcon
  },
  props: {
    patientId: {
      type: String,
      required: true
    },
    changeTab: {
      type: Function,
      required: true
    }
  },
  data () {
    return {
      loading: false
    }
  },
  computed: {
    ...mapGetters({
      staticUrl: 'app/staticUrl',
      authLocale: 'auth/locale',
      authUser: 'auth/user',
      isOnline: 'status/isOnline',
      schedulesByPatient: 'schedule/byPatient'
    })
  },
  methods: {
    ...mapMutations({
      setError: 'alert/setError',
      setSchedule: 'schedule/set',
      resetSchedule: 'schedule/reset',
      setAlert: 'alert/setAlert',
      setCase: 'pcase/set',
      setCaseId: 'schedule/setCaseId'
    }),
    async markPaid (id) {
      try {
        const response = await this.axios.post(
          `/api/schedules/${id}/mark-paid`,
          {}
        )
        const schedule = response.data.data
        this.setSchedule(schedule)
      } catch (err) {
        this.setError(err)
      }
    },
    async createCase (schedule_id) {
      try {
        const params = { schedule_id: schedule_id }
        const response = await this.axios.post('/api/patient-cases', params)
        const c = response.data.data.patient_case
        this.setCase(c)
        this.setCaseId({ id: schedule_id, caseId: c.id })
        if (this.changeTab) {
          this.changeTab('history')
        }
      } catch (err) {
        this.setError(err)
      }
    }
  }
}
</script>
<style lang="scss">
.doctor-schedule {
  .service-item {
    svg {
      width: 20px;
      height: 20px;
    }
  }
}
</style>
<i18n>
{
  "ka": {
      "createSchedule": "ჩანიშვნა",
      "cancel": "გაუქმება",
      "createCase": "ქეისის შექმნა",
      "telemedicine": "ონლაინ",
      "visit": "კლინიკაში",
      "house_call": "გამოძახება",
      "attachCase": "ქეისზე მიმაგრება"
  }
}
</i18n>
